// Проверка на наличие Emoji в строке

export const validatorEmoji = (str) => {
    // eslint-disable-next-line
    const emojiRe = /[\u{1F600}-\u{1F64F}\u{1F300}-\u{1F5FF}\u{1F680}-\u{1F6FF}\u{1F1E0}-\u{1F1FF}\u{2600}-\u{26FF}\u{2700}-\u{27BF}\u{1F900}-\u{1F9FF}\u{1FA00}-\u{1FA6F}\u{1FA70}-\u{1FAFF}\u{1F004}\u{1F0CF}]/u;
    return emojiRe.test(str);
};

// Проверка на наличие цифр в строке
export const validatorDigit = (string) => {
    const digitRegEx = new RegExp(/[0-9]/g);
    return digitRegEx.test(string);
};

// Проверка на наличие символов в строке, исключая emoji.
export const validatorSymbol = (string) => {
    const symbolRegEx = /[^\p{L}\p{N}\p{Emoji}\p{Zs}]/u;
    return symbolRegEx.test(string);
};

// Разрешённые символы: русский/английский алфавит, цифры, пробел, дефис (-) и тире (–)
export const validateAllowedChars = (str) => {
    const allowedCharsRe = /^[\p{L}\p{N}\s\-–().,:'"]+$/u;
    return allowedCharsRe.test(str);
};

// Спецсимволы (пробел, дефис, тире) только в середине текста:
export const validateSpecialPosition = (str) => {
    // Не должно начинаться с пробела, дефиса или тире
    const startsValid = /^[^\s\-–]/u.test(str);
    // Не должно заканчиваться дефисом или тире (пробелы разрешены)
    const endsValid = /[^\-–]$/u.test(str);

    return startsValid && endsValid;
};

// Нельзя состоять только из спецсимволов или только из пробелов:
//    — должно быть хотя бы одна буква или цифра
export const validateNotOnlySpecials = (str) => {
    const hasLetterOrDigitRe = /[\p{L}\p{N}]/u;
    return hasLetterOrDigitRe.test(str);
};